import React from 'react';

import SettingsPageWrapper from '../settings-page-wrapper';
import { ApiKeysSection } from './components/api-keys-section';
import messages from './messages';

/**
 * @returns {JSX.Element} The rendered component.
 */
export const APIPage = () => {
  return (
    <SettingsPageWrapper
      messages={{
        headerMessage: messages.header,
      }}
    >
      <ApiKeysSection />
    </SettingsPageWrapper>
  );
};
